import {rpAppLink} from "@pg-mono/rp-routes";

const configuratorImg = require("../images/baner_konf_desktop.jpg");
const configuratorImgMobile = require("../images/baner_konf_mobile.jpg");

export const INTERNAL_BANNERS = [
    {
        img: configuratorImg,
        mobileImg: configuratorImgMobile,
        link: rpAppLink.propertyConfigurator()
    }
];
import {rpAppLink} from "@pg-mono/rp-routes";

const configuratorImg = require("../images/baner_konf_desktop.jpg");
const configuratorImgMobile = require("../images/baner_konf_mobile.jpg");

export const INTERNAL_BANNERS = [
    {
        img: configuratorImg,
        mobileImg: configuratorImgMobile,
        link: rpAppLink.propertyConfigurator()
    }
];
